import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { PlaneFinderViewer } from '../react/PlaneFinderViewer';
import '../react/styles.css';

// Sentry error reporting (errors only — no performance tracing / session replay).
// The DSN is a public client-side identifier (like the GA tag), safe to embed.
const SENTRY_DSN = 'https://f57181472b6bdbd8af03180a3da797e8@o1388406.ingest.us.sentry.io/4511660182994944';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    enabled: import.meta.env.PROD, // no events from `vite dev`
    // Errors only: omit browserTracing/replay integrations to keep the bundle small.
    // captureConsole matters here: the app deliberately CATCHES its failure modes
    // (model-load errors, capture failures, the dual-Babylon tripwire) and reports
    // them via console.error + UI events — without this integration none of those
    // handled errors would ever reach Sentry.
    integrations: [Sentry.captureConsoleIntegration({ levels: ['error'] })],
    dataCollection: {
      // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
      // userInfo: false,
      // httpBodies: []
    },
  });
}

const container = document.getElementById('root');
if (!container) throw new Error('plane-finder harness: #root not found');

// StrictMode intentionally omitted: it double-invokes effects, which would create
// two Babylon engines on the same canvas in dev.
createRoot(container).render(
  <Sentry.ErrorBoundary fallback={<p style={{ color: '#fff', padding: 24 }}>Something went wrong.</p>}>
    <PlaneFinderViewer />
  </Sentry.ErrorBoundary>,
);
